import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, ISagaCb, PaginationType } from '@typings/requestPayloads'

export interface IListSharedListPayload extends ISagaCb {
    pagination?: PaginationType
    needPopulate?: boolean
    populates?: any[]
    noSaveInStore?: boolean
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listSharedList = createSlice({
    name: 'sharedList/list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListSharedListPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            if (action.payload?.noSaveInStore !== true) {
                state.data = action.payload.data
                state.pagination = {
                    ...state.pagination,
                    skip: action.payload.skip,
                    total: action.payload.total
                }
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const listSharedListActions = listSharedList.actions
export default listSharedList.reducer
